import client from "./client";

export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  is_read: boolean;
  link: string | null;
  created_at: string;
}

export interface NotificationList {
  items: Notification[];
  unread_count: number;
  total: number;
}

export async function listNotifications(
  unread_only = false,
  limit = 50,
): Promise<NotificationList> {
  const { data } = await client.get("/notifications", {
    params: { unread_only, limit },
  });
  return data;
}

export async function markNotificationRead(id: string): Promise<void> {
  await client.post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<number> {
  const { data } = await client.post("/notifications/read-all");
  return data.marked_read;
}
